/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useLazyQuery, useSubscription } from "@apollo/client";
import SalesDone from "src/assets/images/dashboard/salesDoneIcon.png";
import GETUSERSALESCOUNT from "src/graphql/query/dashboard/FigureCards/getSalesCount";
import SALESDONECOUNTCHANGED from "src/graphql/subscriptions/dashboard/salesdonecountchanged";
import { useSnackbar as Snackbar } from "notistack";
import { UseDashboardContext } from "src/context/dashboard";
import { safeJsonParse } from "src/utils/shared/safeJson";
import GeneralCard from "../GeneralCard";

const SalesCard = () => {
  const { enqueueSnackbar } = Snackbar();

  const contextData = UseDashboardContext();
  let storedAgentId: number = 0;
  let globalTimeFrame: string = "today";
  const [salesCount, setSalesCount] = useState<number>(0);

  if (contextData) {
    ({ storedAgentId, globalTimeFrame } = contextData);
  }

  const [
    getSalesCount,
    { data: getUserSalesDoneCountData, loading: getUserTotalChatCountsLoading },
  ] = useLazyQuery(GETUSERSALESCOUNT, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (
      getUserSalesDoneCountData &&
      getUserSalesDoneCountData.getUserSalesDoneCount
    ) {
      if (getUserSalesDoneCountData.getUserSalesDoneCount.success) {
        setSalesCount(getUserSalesDoneCountData.getUserSalesDoneCount.count);
      } else {
        enqueueSnackbar(getUserSalesDoneCountData.getUserSalesDoneCount.error, {
          variant: "error",
        });
      }
    }
  }, [getUserSalesDoneCountData]);

  //
  const {
    data: getUserSalesDoneCountSubscriptionResult,
    error: getUserSalesDoneCountSubscriptionError,
  } = useSubscription(SALESDONECOUNTCHANGED);

  useEffect(() => {
    if (getUserSalesDoneCountSubscriptionError) {
      enqueueSnackbar(getUserSalesDoneCountSubscriptionError.message, {
        variant: "error",
      });
    }
  }, [getUserSalesDoneCountSubscriptionError]);

  useEffect(() => {
    if (
      getUserSalesDoneCountSubscriptionResult &&
      globalTimeFrame === "today"
    ) {
      const { count, agentId } = safeJsonParse<any>(
        getUserSalesDoneCountSubscriptionResult.salesdonecountchanged.result,
        { count: 0, agentId: null },
        "Sales Count",
      );
      if (storedAgentId === Number(agentId)) setSalesCount(count);
    }
  }, [getUserSalesDoneCountSubscriptionResult]);

  //
  useEffect(() => {
    if (storedAgentId) {
      getSalesCount({
        variables: {
          agentId: [storedAgentId],
          timeFrame: globalTimeFrame,
        },
      });
    }
  }, [storedAgentId, globalTimeFrame]);

  return (
    <GeneralCard
      tourId="tour-dashboard-sales-card"
      cardImage={SalesDone}
      count={salesCount}
      loader={getUserTotalChatCountsLoading}
      dropDownValues={globalTimeFrame}
      hideDropdown
      title="Total Sales"
    />
  );
};

export default SalesCard;
